import { Vue } from 'ui.vue';
import { Vuex } from 'ui.vue.vuex';
import { Loc } from 'main.core';
var userStore = Vuex.store({
    state: {
        data: {
            user: {
                ACTIVE_CONTRAGENT: {
                    SBEROFFER: {}
                },
                ACTIVE_ADDRESS: {},
                BASKETS: {},
                BASKET_ID: 0,
                CONTRAGENTS: {},
                ACTIVE_CONTRAGENT_ID: 0,
                ACTIVE_ADDRESS_ID: 0,
                FUSER_ID: 0,
                LOGIN: '',
                ID: 0,
            },
        },
        ajaxUrl: '/local/tools/ajax_multibasket.php',
        submitingCounter: 0
    },
    mutations: {
        // TODO это разобрать на отдельные мутации!
        changeData: function (state, params) {
            if (typeof params == 'undefined') return;
            if (typeof params.userBasket == 'object' && params.userBasket.ID != undefined) {
                debugger;
                if (state.data.user.BASKETS == undefined) state.data.user.BASKETS = {};
                if (!state.data.user.BASKETS[params.userBasket.ID]) {
                    state.data.user.BASKETS[params.userBasket.ID] = params.userBasket;
                }

                if (typeof params.userBasket.ITEMS == 'object') {
                    window.user_basket = {};
                    Object.keys(params.userBasket.ITEMS).forEach(function (i) {
                        if (params.userBasket.ITEMS.hasOwnProperty(i)) {
                            var item = params.userBasket.ITEMS[i];
                            if (item != undefined && item.PRODUCT_ID != undefined) {
                                window.user_basket[item.PRODUCT_ID] = item;
                            }
                        }
                    });
                    // window.user_basket = Object.assign(window.user_basket, params.userBasket.ITEMS);
                }
                // state.data.userBasket = params.userBasket;
                state.data.user.BASKET_ID = params.userBasket.ID;
                if (this.hasModule('basket')) {
                    console.warn('// TODO определиться с вызовом changeData!');
                    this.commit("basket/setBasket", params.userBasket);
                }
                if (typeof params.userBasket.CONTRAGENT != 'object') {
                    if (state.data.user.CONTRAGENTS[params.userBasket.CONTRAGENT_ID] != undefined) {
                        params.userBasket.CONTRAGENT = state.data.user.CONTRAGENTS[params.userBasket.CONTRAGENT];
                    }
                }
                state.data.user.ACTIVE_CONTRAGENT = params.userBasket.CONTRAGENT;
                if (typeof params.userBasket.CONTRAGENT != 'object') {
                    if (state.data.user.ACTIVE_CONTRAGENT != undefined &&
                        params.userBasket != undefined &&
                        params.userBasket.ADDRESS != undefined &&
                        state.data.user.ACTIVE_CONTRAGENT.ADDRESS != undefined &&
                        state.data.user.ACTIVE_CONTRAGENT.ADDRESS[params.userBasket.ADDRESS_ID]
                    ) {
                        params.userBasket.ADDRESS = state.data.user.ACTIVE_CONTRAGENT.ADDRESS[params.userBasket.ADDRESS_ID];
                    } else {
                        // this.dispatch('showNotificate', {
                        //     message: '<div class="text-center">' + BX.message('NO_CONTRAGENT').replace('#BACKURL#', location.pathname) + '</div>',
                        //     position: 'bottom-center',
                        //     autoHide: false,
                        //     type: 'DarkBalloon'
                        // });
                    }
                }
                // TODO избавиться от этого!
                if (params.userBasket.ADDRESS != undefined && (parseInt(params.userBasket.ADDRESS_ID) || parseInt(params.userBasket.ADDRESS.ID))) {
                    state.data.user.ACTIVE_ADDRESS_ID = parseInt(params.userBasket.ADDRESS_ID) || parseInt(params.userBasket.ADDRESS.ID);
                    if (state.data.user.ACTIVE_CONTRAGENT != undefined &&
                        state.data.user.ACTIVE_CONTRAGENT.ADDRESS != undefined
                    ) {
                        if (state.data.user.ACTIVE_ADDRESS_ID == undefined) {
                            var key = Object.keys(state.data.user.ACTIVE_CONTRAGENT.ADDRESS);
                            if (state.data.user.ACTIVE_CONTRAGENT.ADDRESS[key[0]]) {
                                this.commit("changeData", {
                                    address_id: state.data.user.ACTIVE_CONTRAGENT.ADDRESS[key[0]].ID
                                });
                            }
                        } else if (state.data.user.ACTIVE_CONTRAGENT.ADDRESS[state.data.user.ACTIVE_ADDRESS_ID]) {
                            this.commit("changeData", {
                                address_id: state.data.user.ACTIVE_CONTRAGENT.ADDRESS[state.data.user.ACTIVE_ADDRESS_ID].ID
                            });
                        }
                    }
                } else if (typeof (params.userBasket) != "undefined" && typeof (params.userBasket.ADDRESS) != "undefined") {
                    state.data.user.ACTIVE_ADDRESS = {};
                    state.data.user.ACTIVE_ADDRESS_ID = null;
                }
                if (BX('basket_account_number')) {
                    BX.adjust(BX('basket_account_number'), {
                        text: ' (#' + state.data.user.BASKETS[state.data.user.BASKET_ID].ACCOUNT_NUMBER + ')'
                    });
                }
            }
            if (typeof params.userBasketList == 'object') {
                state.data.user.BASKETS = params.userBasketList;
            }
            // Замена всего объекта данных пользователя
            if (typeof params.user == 'object') {
                if (params.user.BASKETS != undefined &&
                    params.user.FUSER_ID != undefined
                ) {
                    state.data.user = params.user;
                } else {
                    this.dispatch('showNotificate', {
                        message: 'Невозможно обновить данные пользователя! Обратитесь к администрации.'
                    });
                }
            }
            if (typeof params.contragent == 'object') {
                if (params.contragent.ID != undefined) {
                    state.data.user.ACTIVE_CONTRAGENT = params.contragent;
                }
                if (typeof state.data.user.ACTIVE_ADDRESS != 'object' && params.contragent.ADDRESS) {
                    var key = Object.keys(params.contragent.ADDRESS);
                    if (key.length == 1) {
                        this.commit("changeData", {
                            address_id: params.contragent.ADDRESS[key[0]].ID
                        });
                        this.dispatch('showNotificate', {
                            message: 'Адрес доставки установлен автоматически.'
                        });
                    }
                }
            }
            if (typeof params.contragent_id != 'undefined' &&
                state.data.user.CONTRAGENTS[params.contragent_id] != undefined &&
                this.hasModule("basket")
            ) {
                this.commit("basket/setContragentId", params.contragent_id);
                // state.data.user.ACTIVE_CONTRAGENT = state.data.user.CONTRAGENTS[params.contragent_id];
                // if (typeof state.data.user.BASKETS == 'object' &&
                //     state.data.user.BASKETS[state.data.user.BASKET_ID] != undefined
                // ) {
                //     state.data.user.BASKETS[state.data.user.BASKET_ID].CONTRAGENT = state.data.user.ACTIVE_CONTRAGENT;
                // }
                // // BX.setCookie(state.data.user.ID + '_ACTIVE_CONTRAGENT_ID', params.contragent_id, { secure: false, path: '/' });
                // state.data.user.ACTIVE_ADDRESS = {
                //     'ID': 0
                // };
                /* var key = Object.keys(state.data.user.ACTIVE_CONTRAGENT.ADDRESS);
                if (key.length == 1) {
                    this.commit("changeData", {
                        address_id: state.data.user.ACTIVE_CONTRAGENT.ADDRESS[key[0]].ID
                    });
                } */
            }
            if (typeof params.address_id != 'undefined' &&
                state.data.user.ACTIVE_CONTRAGENT != undefined &&
                state.data.user.ACTIVE_CONTRAGENT.ADDRESS != undefined &&
                state.data.user.ACTIVE_CONTRAGENT.ADDRESS[params.address_id] != undefined
            ) {
                state.data.user.ACTIVE_ADDRESS = state.data.user.ACTIVE_CONTRAGENT.ADDRESS[params.address_id];
                if (state.data.user.BASKETS[state.data.user.BASKET_ID].ADDRESS == undefined)
                    state.data.user.BASKETS[state.data.user.BASKET_ID]
                // меняем адрес в текущей корзине
                if (state.data.user.BASKETS[state.data.user.BASKET_ID].ADDRESS != params.address_id) {
                    state.data.user.BASKETS[state.data.user.BASKET_ID].ADDRESS = state.data.user.ACTIVE_ADDRESS.ID;
                }
                BX.setCookie(state.data.user.ID + '_CONTRAGENT_' + state.data.user.ACTIVE_CONTRAGENT.ID + '_PODRAZDELENIE_ID', state.data.user.ACTIVE_ADDRESS.ID, {
                    secure: false,
                    path: '/'
                });
            }
            // if (typeof params.contragentBonus == 'object' &&
            //     params.contragentBonus.id != undefined &&
            //     state.data.user.CONTRAGENTS[params.contragentBonus.id] != undefined
            // ) {
            //     state.data.user.CONTRAGENTS[params.contragentBonus.id].BONUS = params.contragentBonus.bonus;
            //     state.data.user.CONTRAGENTS[params.contragentBonus.id].BONUS_SUMM = params.contragentBonus.bonus_summ;
            //     if (params.contragentBonus.id == state.data.user.ACTIVE_CONTRAGENT.ID) {
            //         state.data.user.ACTIVE_CONTRAGENT.BONUS = params.contragentBonus.bonus;
            //         state.data.user.ACTIVE_CONTRAGENT.BONUS_SUMM = params.contragentBonus.bonus_summ;
            //     }
            // }
            // сменили корзину по ID - ищем корзину в списке и переключаем
            if (typeof params.basket_id != 'undefined') {
                if (state.data.user.BASKETS[params.basket_id] == undefined) {
                    var data = {
                        action: 'getbasket',
                        basket_id: params.basket_id,
                    };
                    console.log("Нет корзины! Нужно разобраться!");
                } else if (state.data.user.BASKETS[params.basket_id] != undefined) {
                    state.data.user.BASKET_ID = params.basket_id;
                    this.commit('basket/updateBasket', state.data.user.BASKETS[params.basket_id]);
                }
            }
        },
        updateAddress: function (state, params) {
            if (
                params != undefined &&
                params.ID &&
                params.NAME &&
                state.data.user.CONTRAGENTS[state.basket.CONTRAGENT].ADDRESS[params.ID]
            ) {
                state.data.user.CONTRAGENTS[state.basket.CONTRAGENT].ADDRESS[params.ID] = params;
                this.dispatch('showNotificate', { message: 'Данные адреса обновлены.' });
            } else if (
                params != undefined &&
                params.ID &&
                params.NAME) {
                state.data.user.CONTRAGENTS[state.basket.CONTRAGENT].ADDRESS[params.ID] = params;
                this.dispatch('showNotificate', { message: 'Данные адреса добавлены.' });
            } else {
                this.dispatch('showNotificate', { message: 'Данные адреса не обновлены!' });
            }
        },
        /**
         * обновление данных в записи контраегнта
         * @param {*} state - текущее состояние модуля
         * @param {*} contragentObj - новые данные контрагента
         */
        updateContragent: function (state, contragentObj) {
            if (contragentObj?.ID && this.getters['getContragents'][contragentObj.ID]) {
                // Реактивность ?? // TODO убрать эту дичь!
                state.data.user.CONTRAGENTS = Object.assign({}, this.getters['getContragents']);
                for (const propName in contragentObj) {
                    if (Object.hasOwnProperty.call(contragentObj, propName)) {
                        Vue.set(state.data.user.CONTRAGENTS[contragentObj.ID], propName, contragentObj[propName]);
                    }
                }
                if (this.getters['basket/getContragentId'] == contragentObj.ID) {
                    state.data.user.ACTIVE_CONTRAGENT = this.getters['getContragents'][contragentObj.ID];
                    BX.onCustomEvent('OnAfterContragentUpdate', this.getters.getContragents[contragentObj.ID]);
                }
            } else {
                this.dispatch('showNotificate', { message: 'Данные контрагента не обновлены!' });
            }
        },
        /**
         * обновление данных в записи контраегнта
         * @param {*} state - текущее состояние модуля
         * @param {*} contragentListObj - новые данные контрагентов
         */
        updateContragents: function (state, contragentListObj) {
            // Изменение данных о контрагентах
            if (contragentListObj) {
                for (const i in contragentListObj) {
                    if (Object.hasOwnProperty.call(contragentListObj, i)) {
                        this.commit("updateContragent", contragentListObj[i]);
                        // let contragentObj = contragentListObj[i];
                        // let newContragent = Object.assign(this.getters['getContragents'][contragentObj.ID], contragentObj);
                        // Vue.set(this.getters['getContragents'], contragentObj.ID, newContragent);
                        // if (contragentObj.ID == state.basket.CONTRAGENT) state.data.user.ACTIVE_CONTRAGENT = newContragent;
                    }
                }
                // Реактивность ??
                state.data.user.CONTRAGENTS = Object.assign({}, this.getters['getContragents']);
            } else {
                this.dispatch('showNotificate', { message: 'Данные контрагентов не обновлены!' });
            }
        },
        addBasket: function (state, basket) {
            console.warn('// DEPRECATED and will be deleted in future. Use commit("basket/addBasket") instead');
            this.commit('basket/addBasket', basket);
        },
        updateBasket: function (state, basket) {
            console.warn('// DEPRECATED and will be deleted in future. Use commit("basket/updateBasket") instead');
            this.commit('basket/updateBasket', basket);
        },
    },
    actions: {
        initEventHandler: function (state) {
            if (!state.state.initHandler) {
                BX.ready(BX.proxy(function () {
                    BX.onCustomEvent("OnAfterUserStoreInit");
                }, this));
                state.state.initHandler = true;
            }
        },
        change: function (store, payload) {
            store.commit("changeData", payload);
        },
        // INFO отложенная отправка на сервер!
        submit: (store, data) => {
            return new Promise((resolve, reject) => {
                store.state.submitingCounter++;
                try {
                    if (data == undefined) throw "No data to submit";
                    if (data.url !== undefined && data.action === undefined) throw "No action submited";
                    if (data.url === undefined) data.url = store.state.ajaxUrl;
                    data = store.getters.getAjaxParams(data);
                    BX.ajax({
                        url: data.url,
                        data: data,
                        timeout: (data.timeout ?? 60),
                        method: (data.method ?? 'POST'),
                        dataType: (data.dataType ?? 'json'),
                        async: (data.async ?? true),
                        processData: (data.processData ?? true),
                        scriptsRunFirst: (data.scriptsRunFirst ?? true),
                        emulateOnload: (data.emulateOnload ?? false),
                        start: (data.start ?? true),
                        cache: (data.cache ?? true),
                        onsuccess: BX.proxy(function (result) {
                            store.state.submitingCounter--;
                            // INFO за обработку ответа сервера отвечает вызывающий метод!
                            if (result != undefined && result.error == undefined && !result.errors?.length) {
                                resolve(result);
                            } else {
                                reject(result);
                            }
                        }, store),
                        onfailure: BX.proxy(function (data) {
                            store.state.submitingCounter--;
                            console.log(data);
                            reject(data);
                        }, store)
                    });
                } catch (error) {
                    store.state.submitingCounter--;
                    store.dispatch('errorSend2Server', { item: data, type: error, message: error.message });
                    reject(false);
                }
            });
        },
        errorSend2Server: function (state, error) {
            switch (error.type) {
                case 'timeout':
                    this.dispatch('showNotificate', {
                        message: state.localize('STORE_TIMEOUT')
                    });
                    break;
                default:
                    if (error.message || error.type) {
                        this.dispatch('showNotificate', {
                            message: error.message || error.type
                        });
                    } else {
                        console.error(error);
                        alert(JSON.stringify(error, null, 4));
                    }
                    break;
            }
        },
        showNotificate: function (state, params) {
            try {
                if (params == undefined) throw "No params for notification!";
                params.content = (params.message || params.content);
                if (params.content == undefined) throw "No content for notification!";
                if (params.autoHide === null && params.autoHide === undefined) params.autoHide = true;
                if (params.closeButton === null && params.closeButton === undefined) params.closeButton = true;
                params.content = params.content.replace('#BACKURL#', location.href);
                var className = params.className;
                if (document.body && typeof BX.UI?.Notification?.Center == 'object') {
                    BX.UI.Notification.Center.notify({
                        content: params.content,
                        render: function() {
                            var content = this.getContent();
                            var actions = [];
                            for (let i in this.actions) {
                                let action = this.actions[i];
                                if (action != undefined) {
                                    if (action.getHref()) {
                                        actions.push(
                                            BX.create("a", {
                                                props: {
                                                    className: 'ui-notification-balloon-action',
                                                    href: action.getHref(),
                                                    title: action.getTitle(),
                                                },
                                                text: action.getTitle(),
                                                events: action.events,
                                            })
                                        );
                                    } else {
                                        actions.push(
                                            BX.create("span", {
                                                props: {
                                                    className: 'ui-notification-balloon-action',
                                                    title: action.getTitle(),
                                                },
                                                text: action.getTitle(),
                                                events: action.events,
                                            })
                                        );
                                    }
                                }
                            }
                            return BX.create("div", {
                                props: {
                                    className: "ui-notification-balloon-content " + (className || 'ui-notification-balloon-content-light')
                                },
                                html: BX.type.isDomNode(content) ? null : content,
                                children: (BX.type.isDomNode(content) ? [content] : [
                                    BX.create("div", {
                                        props: {
                                            className: "ui-notification-balloon-message pr-2"
                                        },
                                        style: {
                                            color: '#000'
                                        },
                                        html: content,
                                    }),
                                    BX.create("div", {
                                        props: {
                                            className: "ui-notification-balloon-actions"
                                        },
                                        children: actions
                                    }),
                                    BX.create("div", {
                                        props: {
                                            className: "ui-notification-balloon-close-btn"
                                        },
                                        events: {
                                            click: BX.proxy(function () {
                                                this.close();
                                            }, this)
                                        },
                                    })
                                ]),
                            });
                        },
                        position: params.position || "bottom-right",
                        autoHide: params.autoHide,
                        autoHideDelay: params.autoHideDelay || 2000,
                        closeButton: params.closeButton,
                        category: "vue-notification-" + (params.id || params.category || ''),
                        actions: params.actions
                    });
                } else {
                    alert(params.content);
                }
            } catch (error) {
                console.debug('Notification: error: ', error?.replace(/<\/?[^>]+(>|$)/g, ""));
                alert(error);
            }
        },
    },
    getters: {
        getContragents: function (state, getters, rootState, rootGetters) {
            return state.data.user.CONTRAGENTS;
        },
        /** @deprecated and will be deleted in future. Use getters.getContragents instead */
        contragents: function (state, getters, rootState, rootGetters) {
            console.warn('DEPRECATED and will be deleted in future. Use getters.getContragents instead');
            return state.data.user.CONTRAGENTS;
        },
        /** @deprecated and will be deleted in future. Use getters.basketList instead */
        userBasketList: function (state, getters, rootState, rootGetters) {
            console.warn('DEPRECATED and will be deleted in future. Use getters.basketList instead');
            return state.data.user.BASKETS;
        },
        getBasketList: function (state, getters, rootState, rootGetters) {
            return state.data.user.BASKETS;
        },
        basketList: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED basketList use getBasketList insted");
            return getters.getBasketList;
        },
        user: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED user use getUser insted");
            return getters.getUser;
        },
        getUser: function (state, getters, rootState, rootGetters) {
            return state.data?.user;
        },
        getUserId: function (state, getters, rootState, rootGetters) {
            return getters.getUser?.ID;
        },
        // DEPRECATED moved to basket submodule
        basketNumber: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED contragent_id use basket/basketNumber insted");
            return rootGetters['basket/basketNumber'];
        },
        contragent_id: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED contragent_id use basket/getContragentId insted");
            return rootGetters['basket/getContragentId'];
        },
        getContragent: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED contragent_id use basket/getContragent insted");
            return rootGetters['basket/getContragent'];
        },
        contragent: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED contragent_id use basket/getContragent insted");
            return rootGetters['basket/getContragent'];
        },
        address_id: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED address_id use basket/getAddressId insted");
            return rootGetters['basket/getAddressId'];
        },
        getAddress: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED address use basket/getAddress insted");
            return rootGetters['basket/getAddress'];
        },
        address: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED address use basket/getAddress insted");
            return rootGetters['basket/getAddress'];
        },
        basket_id: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED basket_id use basket/getId insted");
            return rootGetters['basket/getId'];
        },
        basket: function (state, getters, rootState, rootGetters) {
            console.warn("// DEPRECATED basket use basket/basket insted");
            return rootGetters['basket/basket'];
        },
        isLoading: (state, getters, rootState, rootGetters) => {
            return state.submitingCounter > 0;
        },
        getLoadingInfo: (state, getters, rootState, rootGetters) => {
            return Loc.getMessage('VUE_N_REQUESTS').replace("#N#", state.submitingCounter)
        },
        isUserCanSendCart: (state, getters, rootState, rootGetters) => {
            return getters.getUser?.["UF_ZAPRETOTPRAVKAZAK"] != true
        },
        getAjaxParams: (state, getters, rootState, rootGetters) => (data) => {
            data = data || {};
            data.via_ajax = 'Y';
            data.sessid = BX.bitrix_sessid();
            data.user_id = getters['getUserId'];
            data.user_login = getters['getUser']?.LOGIN;
            return data;
        }
    },
    modules: {}
});
userStore.dispatch('initEventHandler');
function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}
window.userStore = userStore;
export { userStore, storageAvailable };
